module.exports = __webpack_public_path__ + "media/src/images/certificates/certificate_frame-a1e8cf181b3787884fd46080912c99f3.png";